import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { UserJob } from '../../../signup.types';
import { Hyperlink } from '../../../../components/Hyperlink';
import { Checkbox } from '../../../../components/checkbox/Checkbox';

type Props = {
  jobTitle: string;
  handleTerms: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  agreedToTerms: boolean;
  USER_JOBS: Array<UserJob>;
};

export const SignUpFormTerms: FC<Props> = ({
  USER_JOBS,
  jobTitle,
  handleTerms,
  agreedToTerms,
}) => {
  const selection /* : ?UserJob */ = USER_JOBS.find(
    element => element.jobTitle === jobTitle,
  );
  const source = 'signup';
  return (
    <button
      type="button"
      onClick={handleTerms}
      className="signup-form__terms"
      name="check-terms"
      data-test-id="check-terms"
    >
      <span className="signup-form__terms__icon">
        <Checkbox checked={agreedToTerms} />
      </span>{' '}
      <span className="signup-form__terms__text">
        <FormattedMessage id="signup/routes/user/form/SignUpFormTerms.tsx/1" />{' '}
        <Hyperlink
          className="signup-form__terms__link"
          href="/cgu"
          source={source}
          onClick={e => e.stopPropagation()}
          target="_blank"
        >
          <FormattedMessage id="signup/routes/user/form/SignUpFormTerms.tsx/2" />
        </Hyperlink>{' '}
        <FormattedMessage id="signup/routes/user/form/SignUpFormTerms.tsx/3" />{' '}
        <Hyperlink
          className="signup-form__terms__link"
          href="/cgv"
          source={source}
          onClick={e => e.stopPropagation()}
          target="_blank"
        >
          <FormattedMessage id="signup/routes/user/form/SignUpFormTerms.tsx/4" />
        </Hyperlink>
        {selection && !selection.isPro && (
          <>
            {' '}
            <FormattedMessage id="signup/routes/user/form/SignUpFormTerms.tsx/5" />{' '}
            <Hyperlink
              className="signup-form__terms__link"
              href="/pdf/cgv.pdf"
              source={source}
              onClick={e => e.stopPropagation()}
              target="_blank"
            >
              <FormattedMessage id="signup/routes/user/form/SignUpFormTerms.tsx/6" />
            </Hyperlink>{' '}
          </>
        )}
        <br />
        <FormattedMessage id="signup/routes/user/form/SignUpFormTerms.tsx/7" />{' '}
        <Hyperlink
          className="signup-form__terms__link"
          href="/donnees_personnelles"
          source="signup"
          onClick={e => e.stopPropagation()}
          target="_blank"
        >
          <FormattedMessage id="signup/routes/user/form/SignUpFormTerms.tsx/8" />
        </Hyperlink>
      </span>
    </button>
  );
};
